import { environment } from 'src/environments/environment';

/**
 * תיאור קצר בעברית לכל מפתח phase — מוצג בסוגריים אחרי ה־JSON בלוג CHACK_PHPRINT.
 * מפתחות מורכבים: `phase:reason` כשיש שדה reason (למשל filesPoll.skip).
 */
const PH_PRINT_DIAG_PHASE_CTX: Record<string, string> = {
  'phTable.getProduct$.emit': 'בעת בחירת/החלפת מוצר PH ב־getProduct$ (לפני טעינת מוצר מלא)',
  'phTable.beginProductSwitch': 'תחילת החלפת מוצר: ניקוי UI מצב קודם',
  'phTable.clearUiForProductSwitch:done': 'אחרי ניקוי UI כשמחליפים מוצר PH',
  'phTable.runProductSubscription:start': 'הרצת מנוי מוצר — טעינת מוצר מהשרת',
  'phTable.runProductSubscription:afterLoadProduct': 'אחרי שהמוצר נטען בהצלחה (לפני handlePhPrintingService)',
  'phTable.runProductSubscription:catch': 'שגיאה בטעינת מוצר ברמת המנוי',
  'phTable.runProductSubscription:finally': 'סיום מנוי מוצר (הצלחה או כישלון)',
  'phTable.loadModel:abortNoScene': 'עצירת loadModel — אין סצנת Three.js',
  'phTable.loadModel:skipAlreadyLoading': 'דילוג על loadModel — כבר בתהליך טעינת מודל',
  'phTable.loadModel:skipDupMatchFile': 'דילוג — אותו mesh matchFile כבר נבנה לאחרונה',
  'phTable.loadModel:skipDupDynamic': 'דילוג — אותו mesh דינמי כבר נבנה לאחרונה',
  'phTable.loadModel:start': 'התחלת טעינת מודל/תצוגה תלת־ממדית',
  'phTable.loadModel:skipInvalidPaperTypeForProduct':
    'דילוג על טעינת OBJ — paperType שמור לא שייך לסוגי המוצר הנוכחי (שארית ממוצר אחר)',
  'phTable.loadModel:buildVariableMesh': 'בניית mesh משתנה (קנבס/matchFile דינמי)',
  'phTable.applyMatchFilePrintingBounds:http': 'לאחר שליחת מידות הדפסה (matchFile) לשרת',
  'phTable.applyDynamicPrintingBounds:http': 'לאחר שליחת מידות הדפסה (dynamic) לשרת',
  'phTable.updatePrintingDimensionsCm:done': 'סיום חישוב/עדכון מידות הדפסה בס״מ בממשק',
  'phTable.scheduleCoalescedVariable3DViewLoad': 'תזמון מאוחד של טעינת תצוגת 3D משתנה',
  'phTable.scheduleCoalescedVariable3DViewLoad:skipNoPrintDims':
    'דילוג על תזמון 3D — אין מידות הדפסה תקינות ב-printSettings (למשל אחרי תשובת שרת חלקית)',
  'phTable.matchFileSyncFinally.scheduleVariable3D': 'אחרי סנכרון matchFile ברקע — תזמון תצוגת 3D',
  'phTable.tearDownFilesPollInterval': 'עצירת interval פול הקבצים (יציאה מהקומפוננטה/ניווט)',
  'phTable.handlePhPrintingService:start': 'כניסה ל־handlePhPrintingService אחרי שהמשתמש/מוצר מוכנים',
  'phTable.handlePhPrintingService:switchPhPrintProduct.failed': 'כשל בקריאת switchPhPrintProduct בעת החלפת מוצר',
  'phTable.handlePhPrintingService:afterBranchLocalStorage': 'אחרי סנכרון branch/localStorage והחלטה אם לאפס הגדרות',
  'phTable.handlePhPrintingService:startFilesPollInterval': 'הפעלת פול תקופתי של רשימת קבצים מהשרת',
  'phTable.filesPoll.snapshot': 'תמונת מצב של קבצים שהגיעו מה־API (לפני מיזוג ל־UI)',
  'phTable.filesPoll.next': 'עיבוד תוצאת פול — לפני סננים (collect/pause/switch)',
  'phTable.filesPoll.skip:pauseTableUpdate': 'פול דולג — ממתינים לתשובת מחיקה/עדכון טבלה',
  'phTable.filesPoll.skip:isProductSwitching': 'פול דולג — בתהליך החלפת מוצר',
  'phTable.filesPoll.skip:isUpdatingFileSettings':
    'פול דולג — עדכון הגדרות קובץ לשרת בתהליך (מונע דריסת printSettings מקומית)',
  'phTable.filesPoll.invalidPaperType.skipClear': 'נייר שמור לא תואם למוצר — לא מנקים הגדרות אוטומטית',
  'phTable.filesPoll.2d.skipNoDiff': 'אין שינוי משמעותי ברשימת הקבצים — לא מרעננים טבלה',
  'phTable.filesPoll.nanPriceNumber.skipClear': 'מחיר לא מספרי מהשרת — לא מאפסים הגדרות',
  'phTable.filesPoll.2d.applyList': 'מיישמים רשימת קבצים חדשה מהפול לטבלה ולתצוגה',
  'phTable.filesPoll.sanitizedInvalidPaperTypes':
    'נוקו סוגי נייר/חומר לא תקפים למוצר הנוכחי ברשימת הקבצים מהפול',
  'phTable.filesPoll.skipOnChooseSameDisplayedPreview': 'דילוג על onChoose — אותו קובץ/תצוגה כבר מוצגים',
  'phTable.filesPoll.rebindSameSelectionNoPreview':
    'אותו קובץ/עמוד מהפול — rebind מחיר/מטא בלבד, בלי onChoose וללא ריענון תצוגה מקדימה',
  'phTable.rollPlotDims.hydrateFromPreview': 'מילוי מידות רול/פלוטר מתצוגת הפריוויו',
  'phTable.onChooseImage': 'בחירת קובץ/עמוד תמונה (שורה בטבלה או מעבר עמוד)',
  'phTable.onChooseImage:sanitizedInvalidPaperType':
    'נוקה paperType שלא תואם למוצר הנוכחי — יש לבחור חומר/סוג מהרשימה',
  'phTable.onChooseImage:afterUpdatePrintingDimensionsCm': 'אחרי עדכון מידות הדפסה בעקבות בחירת תמונה',
  'phTable.onChooseImage:scheduleUpdatePreview': 'תזמון עדכון פריוויו 2D',
  'phTable.onChooseImage:defer3DUntilMatchFileSync': 'דחיית 3D עד סיום סנכרון matchFile מהפול',
  'phTable.onChooseImage:skipScheduleBoundsHttp': 'לא פותחים HTTP מידות — כבר נפתח מ־applyMatchFile וכו׳',
  'phTable.onChooseImage:skipScheduleHttpInFlight': 'לא פותחים HTTP מידות — בקשה קודמת עדיין רצה',
  'phTable.onChooseImage:schedule3DFallback': 'תזמון גיבוי לטעינת 3D כשלא נדרש HTTP מידות',
  'phTable.onFileSettingsChange:enter': 'שינוי הגדרות הדפסה (נייר, סיבוב, מידות וכו׳)',
  'phTable.onFileSettingsChange:httpOk.staleIgnored': 'תשובת HTTP ישנה — כבר הגיעה סדרה חדשה יותר',
  'phTable.onFileSettingsChange:httpOk.skipScheduleOtherFile': 'לא מתזמנים 3D — התשובה לקובץ אחר מהנוכחי',
  'phTable.onFileSettingsChange:httpOk.defer3DMatchFileSync': 'דחיית תזמון 3D — סנכרון matchFile ברקע פעיל',
  'phTable.onFileSettingsChange:httpOk.skipVariable3D_dupAfterMatchFileFinally':
    'מניעת תזמון כפול — matchFile כבר תיזם 3D בזמן ש־HTTP מידות עדיין רץ',
  'phTable.onFileSettingsChange:httpOk.scheduleVariable3D': 'אחרי עדכון שרת מוצלח — תזמון תצוגת 3D משתנה',
  'phTable.onFileSettingsChange:httpOk.skipVariable3D_noUserPreview':
    'דילוג על תזמון 3D — עדכון מפול/רקע או isToUpdatePreview=false (לא שינוי משתמש)',
  'phTable.onFileSettingsChange:httpOk.skipVariable3D_dupAfterOptimistic':
    'דילוג על תזמון 3D ב-httpOk — כבר נבנה optimistic אחרי לחיצת משתמש, או בקשה בלי paperType',
  'phTable.onFileSettingsChange:httpOk.skipVariable3D_noRenderChange':
    'דילוג על תזמון 3D ב-httpOk — אותו renderKey כמו התצוגה שכבר מוצגת',
  'phTable.onChooseImage:calcTotalOrderPrice': 'חישוב מחיר הזמנה כולל אחרי בחירת תמונה/קובץ',
  'phTable.onDeleteFileOrImageError.skip': 'שגיאת טעינת תמונה ממוזערת — לא מוחקים קובץ אוטומטית',
  'phTable.uploader.onAfterAddingFile': 'מיד אחרי שהמשתמש בחר קובץ להעלאה',
  'phTable.uploader.onCompleteItem': 'סיום העלאת פריט בנגן ההעלאות',
  'navPrint.NavigationEnd': 'סיום ניווט Angular — עדכון מצב שירות הדפסה/ענף',
  'navPrint.getPrintingService$': 'זרימת getPrintingService (מסלול הדפסה נבחר)',
  'navPrint.getBranch$': 'זרימת getBranch (ענף/מוצר נבחר בתפריט)',
  'navPrint.goToBranch': 'מעבר לענף אחר מתוך תפריט ההדפסה',
};

/** תיאור לפי label ב־phDiag כשאין מפתח phase ייחודי */
const PH_PRINT_DIAG_LABEL_CTX: Record<string, string> = {
  'poll files snapshot': 'תמונת דיבוג של דגימת הקבצים מהפול (שלב snapshot)',
  'thumb load error (ph) — skip auto-delete': 'כשל בטעינת thumbnail — לא מוחקים תמונה אוטומטית',
};

function resolvePhPrintDiagCtx(payload: Record<string, unknown>): string | undefined {
  const manual =
    typeof (payload as any).ctx === 'string'
      ? String((payload as any).ctx).trim()
      : '';
  if (manual) {
    return manual;
  }
  const phase = typeof payload['phase'] === 'string' ? String(payload['phase']) : '';
  const reason = typeof payload['reason'] === 'string' ? String(payload['reason']) : '';
  const label = typeof payload['label'] === 'string' ? String(payload['label']) : '';
  const composite = phase && reason ? `${phase}:${reason}` : '';
  if (composite && PH_PRINT_DIAG_PHASE_CTX[composite]) {
    return PH_PRINT_DIAG_PHASE_CTX[composite];
  }
  if (phase && PH_PRINT_DIAG_PHASE_CTX[phase]) {
    return PH_PRINT_DIAG_PHASE_CTX[phase];
  }
  if (label && PH_PRINT_DIAG_LABEL_CTX[label]) {
    return PH_PRINT_DIAG_LABEL_CTX[label];
  }
  if (phase) {
    return `שלב: ${phase}`;
  }
  if (label) {
    return `תווית: ${label}`;
  }
  return undefined;
}

/**
 * לוג אבחון ל־/phprint — רק !production. כל השורות מתחילות ב־CHACK_PHPRINT + JSON.stringify.
 * בסוף השורה מוצגים בסוגריים מתי/הקשר — ממפת PH_PRINT_DIAG_PHASE_CTX לפי phase (או ctx ידני).
 * payload חייב להיות סריאלי (בלי מעגליות).
 */
export function chackPhprintDiag(payload: Record<string, unknown>): void {
  if (environment.production) {
    return;
  }
  const line = { ...payload, _t: Date.now() };
  const ctxHint = resolvePhPrintDiagCtx(line);
  const suffix = ctxHint ? ` (${ctxHint})` : '';
  try {
    const label = typeof (line as any)?.label === 'string' ? String((line as any).label) : '';
    const prefix = label ? `CHACK_PHPRINT - ${label} ` : 'CHACK_PHPRINT ';
    // Remove "label" from JSON payload to keep it clean (label is already in prefix)
    if (label) {
      const { label: _omit, ...rest } = line as any;
      console.log(`${prefix}${JSON.stringify(rest)}${suffix}`);
      return;
    }
    console.log(`${prefix}${JSON.stringify(line)}${suffix}`);
  } catch {
    console.log('CHACK_PHPRINT', line, suffix);
  }
}

/**
 * Helper to keep logs small & behavior-focused.
 * Usage: phDiag('choose paperType', { phase: '...', fileId: ... })
 * אפשר להוסיף ctx: 'משפט קצר' לעקיפת התיאור האוטומטי מהמפה.
 */
export function phDiag(label: string, payload: Record<string, unknown>): void {
  chackPhprintDiag({ label, ...payload });
}

/** תיאורים ללוג CHAECK_UPDATE_PAPERTYPE (מסלול PH שאינו 3DPrint — נייר/חומר והגדרות דף) */
const UPDATE_PAPERTYPE_DIAG_PHASE_CTX: Record<string, string> = {
  'phTable.ui:paperTypeToggle':
    'לחיצה על כפתור סוג נייר/חומר (mat-button-toggle) — לפני שליחת עדכון לשרת',
  'phTable.onFileSettingsChange:enter': 'כניסה ל־onFileSettingsChange — לפני בניית payload ושליחת HTTP',
  'phTable.onFileSettingsChange:httpSend': 'שליחת PUT לשרת (קובץ ± עמוד לפי מוצר רב־סוגים)',
  'phTable.onFileSettingsChange:httpOk': 'תשובת שרת OK — אחרי מיזוג קובץ/עמוד והמשך תצוגה',
  'phTable.onFileSettingsChange:httpOk.staleIgnored': 'תשובת HTTP ישנה — כבר נשלחה סדרה חדשה יותר',
  'phTable.onFileSettingsChange:httpError': 'שגיאת רשת/שרת בעדכון הגדרות דפסה',
  'phTable.filesPoll.skip:isUpdatingFileSettings':
    'פול דולג — עדכון הגדרות לשרת בתהליך (מונע דריסת paperType מקומי)',
  'phTable.filesPoll.invalidPaperType.skipClear':
    'נייר מהפול לא תואם למוצר — לא מנקים הגדרות (אבחון)',
  'phTable.filesPoll.sanitizedInvalidPaperTypes': 'אחרי פול — נוקו סוגי נייר לא תקפים מהרשימה',
  'phTable.onChooseImage:sanitizedInvalidPaperType':
    'אחרי בחירת עמוד — נוקה paperType שלא שייך למוצר הנוכחי',
  'phTable.onChooseImage:afterUpdatePrintingDimensionsCm':
    'אחרי עדכון מידות הדפסה בעקבות בחירת תמונה (כולל מצב paper)',
};

function resolveUpdatePaperTypeDiagCtx(payload: Record<string, unknown>): string | undefined {
  const manual =
    typeof (payload as any).ctx === 'string'
      ? String((payload as any).ctx).trim()
      : '';
  if (manual) return manual;
  const phase = typeof payload['phase'] === 'string' ? String(payload['phase']) : '';
  const reason = typeof payload['reason'] === 'string' ? String(payload['reason']) : '';
  const composite = phase && reason ? `${phase}:${reason}` : '';
  if (composite && UPDATE_PAPERTYPE_DIAG_PHASE_CTX[composite]) {
    return UPDATE_PAPERTYPE_DIAG_PHASE_CTX[composite];
  }
  if (phase && UPDATE_PAPERTYPE_DIAG_PHASE_CTX[phase]) {
    return UPDATE_PAPERTYPE_DIAG_PHASE_CTX[phase];
  }
  if (phase) return `שלב: ${phase}`;
  return undefined;
}

/**
 * לוג ייעודי לזרימת עדכון נייר/חומר והגדרות דף ב־/phprint (לא מוצרי 3DPrint).
 * רק !production. קידומת קבועה: CHAECK_UPDATE_PAPERTYPE
 */
export function chaeckUpdatePaperTypeDiag(payload: Record<string, unknown>): void {
  if (environment.production) {
    return;
  }
  const line = { ...payload, _t: Date.now() };
  const ctxHint = resolveUpdatePaperTypeDiagCtx(line);
  const suffix = ctxHint ? ` (${ctxHint})` : '';
  try {
    console.log(`CHAECK_UPDATE_PAPERTYPE ${JSON.stringify(line)}${suffix}`);
  } catch {
    console.log('CHAECK_UPDATE_PAPERTYPE', line, suffix);
  }
}

/** תיאורים ללוג CHAECK_3D_PREVIEW (מסלול תצוגה תלת־ממדית ב־/phprint) */
const THREE_D_PREVIEW_DIAG_PHASE_CTX: Record<string, string> = {
  'phTable.showPreview:enter': 'פתיחת תצוגה מקדימה תלת־ממדית',
  'phTable.showPreview:skipMissingState': 'דילוג על פתיחת 3D preview — חסרים קובץ/חומר/הגדרות',
  'phTable.hidePreview': 'סגירת תצוגה מקדימה תלת־ממדית',
  'phTable.schedule3D:request': 'בקשת תזמון לטעינת/בניית תצוגת 3D משתנה',
  'phTable.schedule3D:skipNoPrintDims': 'דילוג על תזמון 3D — אין מידות הדפסה תקינות',
  'phTable.schedule3D:skipBypassTooSoon': 'דילוג על תזמון bypass קרוב מדי לתזמון משתמש/HTTP',
  'phTable.schedule3D:skipDeferredToMatchFile': 'דילוג על תזמון — ממתינים לסנכרון matchFile',
  'phTable.schedule3D:skipNoRenderChange': 'דילוג על תזמון — אותו 3D preview כבר נבנה ואין שינוי בהגדרות',
  'phTable.schedule3D:optimisticUserChange': 'תזמון מיידי אחרי שינוי משתמש — לפני תשובת שרת',
  'phTable.schedule3D:timerArmed': 'Timer לטעינת 3D הופעל',
  'phTable.schedule3D:timerFire': 'Timer לטעינת 3D הופעל בפועל',
  'phTable.schedule3D:abortUnstableSize': 'ביטול טעינת 3D — קונטיינר לא יציב או serial השתנה',
  'phTable.loadModel:abortNoScene': 'ביטול loadModel — אין scene',
  'phTable.loadModel:skipAlreadyLoading': 'דילוג על loadModel — טעינה כבר רצה',
  'phTable.loadModel:skipDupMatchFile': 'דילוג על matchFile — אותו mesh נטען לאחרונה',
  'phTable.loadModel:skipDupDynamic': 'דילוג על dynamic — אותו mesh נטען לאחרונה',
  'phTable.loadModel:skipInvalidPaperTypeForProduct': 'דילוג על 3D — סוג חומר לא שייך למוצר הנוכחי',
  'phTable.loadModel:start': 'תחילת טעינת/בניית מודל 3D',
  'phTable.loadModel:buildVariableMesh': 'בניית mesh משתנה (dynamic/matchFile)',
  'phTable.loadModel:variableMeshReady': 'mesh משתנה נבנה והגיאומטריה מוכנה',
  'phTable.loadModel:objRequest': 'בקשת טעינת OBJ',
  'phTable.loadModel:objLoaded': 'OBJ נטען בהצלחה',
  'phTable.loadModel:objAllLoaded': 'כל קבצי ה־OBJ נטענו — מתחילים טקסטורות',
  'phTable.loadModel:objReady': 'מודל OBJ מוכן אחרי טקסטורות/זום',
  'phTable.loadModel:error': 'שגיאה בטעינת מודלי 3D',
  'phTable.loadModel:skipNoCurrentProductType': 'דילוג על loadModel — אין currentProductType',
  'phTable.texture:skipMissingImage': 'דילוג על texture תמונה — חסר thumbnail/currentImage/currentProductType',
  'phTable.texture:start': 'תחילת טעינת texture',
  'phTable.texture:staleIgnored': 'texture נטען אך שייך לבנייה ישנה — מתעלמים',
  'phTable.texture:applied': 'texture הוחל על המודל',
  'phTable.texture:error': 'שגיאה בטעינת texture',
  'phTable.texture:end': 'סיום טעינת texture',
  'phTable.texture:allReady': 'כל הטקסטורות הסתיימו וה־3D מוכן',
  'phTable.autoRotation:readyCheck': 'בדיקת מוכנות להפעלת סיבוב אוטומטי',
  'phTable.autoRotation:startQueued': 'תוזמן סיבוב אוטומטי אחרי מוכנות',
};

function resolve3DPreviewDiagCtx(payload: Record<string, unknown>): string | undefined {
  const manual =
    typeof (payload as any).ctx === 'string'
      ? String((payload as any).ctx).trim()
      : '';
  if (manual) return manual;
  const phase = typeof payload['phase'] === 'string' ? String(payload['phase']) : '';
  if (phase && THREE_D_PREVIEW_DIAG_PHASE_CTX[phase]) {
    return THREE_D_PREVIEW_DIAG_PHASE_CTX[phase];
  }
  if (phase) return `שלב: ${phase}`;
  return undefined;
}

/**
 * לוג ייעודי לכל מסלול תצוגה תלת־ממדית ב־/phprint.
 * רק !production. קידומת קבועה: CHAECK_3D_PREVIEW
 */
export function chaeck3DPreviewDiag(payload: Record<string, unknown>): void {
  if (environment.production) {
    return;
  }
  const line = { ...payload, _t: Date.now() };
  const ctxHint = resolve3DPreviewDiagCtx(line);
  const suffix = ctxHint ? ` (${ctxHint})` : '';
  try {
    console.log(`CHAECK_3D_PREVIEW ${JSON.stringify(line)}${suffix}`);
  } catch {
    console.log('CHAECK_3D_PREVIEW', line, suffix);
  }
}

/**
 * נתונים ושירותים משותפים למסלול PH: מחירי איסוף/משלוח, זיהוי מוצר תלת־ממד, וכו׳.
 *
 * מחירי איסוף/משלוח (בשקלים) – מקור אחד לכל הקומפוננטות שמשתמשות ב־getPhCollectionServicePrice.
 * points / distribution: 15 · delivery: 40 · appointment: 30 · pickup ואחרים: 0
 */
export function getPhCollectionServicePrice(service: string | null | undefined): number {
  const s = service || '';
  if (s === 'points' || s === 'distribution') {
    return 15;
  }
  if (s === 'delivery') {
    return 40;
  }
  if (s === 'appointment') {
    return 30;
  }
  return 0;
}

const PH_THREE_D_PRINT_PRODUCT_IDS = new Set(['FDM', 'MJF', 'SLA']);

/**
 * האם מדובר בהדפסת תלת־ממד (מזהה מוצר PH כמו ב־home_branches_list).
 * true עבור FDM, MJF, SLA בלבד.
 */
export function isPhThreeDPrintProductId(productId: string | null | undefined): boolean {
  if (productId == null || productId === '') {
    return false;
  }
  return PH_THREE_D_PRINT_PRODUCT_IDS.has(productId.trim());
}

/**
 * אייקון "מערכת PH" מול הדפסה רגילה – לפי `product.type` / `product.name` (כמו choose-product, סיכום הזמנה, צ'אט).
 * 3Dprint/3D או FDM|MJF|SLA|מזהה 3Dprint → 3dprint; אחרת phprint.
 */
export function getPhSystemIconSrcFromProduct(
  product: { name?: string; type?: string } | null | undefined
): string {
  if (!product) {
    return 'assets/images/phprint-icon.svg';
  }
  const t = (product.type || '').trim();
  if (t === '3Dprint' || t === '3D') {
    return 'assets/images/3dprint-icon.svg';
  }
  const n = (product.name || '').trim();
  if (n === '3Dprint' || isPhThreeDPrintProductId(n)) {
    return 'assets/images/3dprint-icon.svg';
  }
  return 'assets/images/phprint-icon.svg';
}

/** אייקון PH כשמוכרים רק מזהה מוצר/נתיב (תפריט) – ללא type */
export function getPhPrintingNavIconSrc(phProductId: string | null | undefined): string {
  return getPhSystemIconSrcFromProduct({ name: phProductId || undefined });
}

/**
 * מפתח תרגום לקידומת שורת מיקום PH (חלונית right-place, ניווט מהדפסה):
 * «הדפסה במשלוח» לעומת «הדפסת תלת מימד» — לפי מזהה מוצר (canvas, FDM, 3Dprint, …).
 */
export function getPhSystemTitleKeyFromProductId(
  productId: string | null | undefined
): string {
  const id = (productId || '').trim();
  if (id === '3Dprint' || isPhThreeDPrintProductId(id)) {
    return 'choose-system.title-3dprint';
  }
  return 'choose-system.title-phprint';
}

/** נתיבי בחירת מוצר PH (מפוצלים מ־/product) */
export const PH_PRODUCT_ROUTE_3D = '/3dproduct';
export const PH_PRODUCT_ROUTE_PRINT = '/phproduct';

/** ל־router.navigate – מסננים ב־choose-product לפי product.type */
export function getPhProductChooserCommandsFromProductType(
  productType: string | null | undefined
): string[] {
  return productType === '3Dprint' ? [PH_PRODUCT_ROUTE_3D] : [PH_PRODUCT_ROUTE_PRINT];
}

/**
 * כשאין עדיין אובייקט product – לפי מזהה מוצר ב־branch (רק `3Dprint` הוא מסלול type 3Dprint).
 */
export function getPhProductChooserCommandsFromBranchId(
  branchProductId: string | null | undefined
): string[] {
  const id = (branchProductId || '').trim();
  return id === '3Dprint' ? [PH_PRODUCT_ROUTE_3D] : [PH_PRODUCT_ROUTE_PRINT];
}

const KAPA_PRODUCT_NAME = 'kapa';
const CANVAS_PRODUCT_NAME = 'canvas';

/**
 * מקטע שני במפתח i18n — legacy מ־sizeMode: `dynamic` / `matchFile` מתמזג לשם ה־type כמו ב־DB (למשל kapa+kapa, canvas+canvas).
 */
export function phProductMaterialSegment(
  productName: string | null | undefined,
  materialName: string | null | undefined
): string {
  const p = String(productName ?? '').trim();
  const m = String(materialName ?? '').trim();
  if (p === KAPA_PRODUCT_NAME && (m === 'dynamic' || m === 'matchFile')) {
    return KAPA_PRODUCT_NAME;
  }
  if (p === CANVAS_PRODUCT_NAME && (m === 'dynamic' || m === 'matchFile')) {
    return CANVAS_PRODUCT_NAME;
  }
  return m;
}

const PH_NAME_PREFIX = 'product-type.name';
const PH_NAME_SHORT_PREFIX = 'product-type.name-short';

/** שם מלא: `product-type.name.[מוצר].[חומר]` (למשל `product-type.name.kapa.kapa`). */
export function phProductMaterialI18nKey(
  productName: string | null | undefined,
  materialName: string | null | undefined
): string {
  const p = String(productName ?? '').trim();
  const seg = phProductMaterialSegment(productName, materialName);
  return `${PH_NAME_PREFIX}.${p}.${seg}`;
}

/** שם קצר: `product-type.name-short.[מוצר].[חומר]`. */
export function phProductMaterialShortI18nKey(
  productName: string | null | undefined,
  materialName: string | null | undefined
): string {
  const p = String(productName ?? '').trim();
  const seg = phProductMaterialSegment(productName, materialName);
  return `${PH_NAME_SHORT_PREFIX}.${p}.${seg}`;
}

/** תיאור / tooltip: `product-type.name.[מוצר].[חומר].exp` */
export function phProductMaterialExpI18nKey(
  productName: string | null | undefined,
  materialName: string | null | undefined
): string {
  return `${phProductMaterialI18nKey(productName, materialName)}.exp`;
}
